import React, { type FC } from 'react';
import { useHistory } from 'react-router';
import { FlexBox, Button } from '@is24at/react-ui-core';
import { ArrowLeft } from '@is24at/react-ui-core/Icons';
import styles from './BackButton.scss';

const DEFAULT_PATH = '/anbieter/suchen/immobilienmakler/oesterreich';

const goBack = (history: any) => {
  if (document?.referrer?.indexOf(window.location.origin) === 0) {
    history.goBack();
  } else {
    window.location.replace(DEFAULT_PATH);
  }
};

export const BackButton: FC = () => {
  const history = useHistory();
  return (
    <FlexBox className="mt-8 mb-8">
      <Button
        className={styles['back-button']}
        displayType="link"
        aria-label="Zurück"
        onClick={() => goBack(history)}
      >
        <ArrowLeft className="mr-12" size={24} />
      </Button>
    </FlexBox>
  );
};
